import { jsx as _jsx } from "react/jsx-runtime";
import { View } from "react-native";
/**
 * A spacing / dividing element between sections in the UI.
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-79}
 */ export function Divider(param) {
    var style = param.style;
    return /*#__PURE__*/ _jsx(View, {
        style: [
            {
                height: 1,
                backgroundColor: '#E2E2E9',
                marginVertical: 10
            },
            style
        ]
    });
}
export default Divider;
